'use strict';

var firstStepsModule = angular.module('t2g.firstSteps', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = firstStepsModule;

firstStepsModule.config(function($stateProvider) {
  $stateProvider.state('private.main.firstSteps', {
    url: '/firstSteps',
    title: 'First Steps',
    templateUrl: '/config/coachfrog/modules/firstSteps/FirstStepsView.html',
    controller: 'FirstStepsCtrl',
    resolve: {
      employees: function(ResourceDA) {
        return ResourceDA.list('employee').then(function(response) {
          return response.resources;
        });
      },
    },
  });
});

firstStepsModule.controller('FirstStepsCtrl', function(
  $scope,
  $state,
  gettextCatalog,
  OfficeModel,
  OfficeDA,
  Notification,
  employees,
) {
  $scope.disableFirstSteps = function() {
    OfficeDA.get().then(function(office) {
      var officeToUpdate = _.cloneDeep(office);

      if (!officeToUpdate || !officeToUpdate.settings) return;

      officeToUpdate.settings.showFirstSteps = false;

      OfficeModel.update(officeToUpdate, function(error) {
        if (error) {
          Notification.addErrorMessage(
            gettextCatalog.getString("can't update settings (Error: {{error}})", { error: error }),
          );
        } else {
          Notification.addSuccessMessage(gettextCatalog.getString('First steps deactivated'));
          $state.go('private.main.calendar', {}, { reload: true });
        }
      });
    });
  };
});



// WEBPACK FOOTER //
// ./src/config/coachfrog/modules/firstSteps/firstStepsModule.js